module.exports = __webpack_public_path__ + "idealnaya_ipoteka.9fa12a63e6a9807b6938fee4f9c6faf6.jpg";